import { render, staticRenderFns } from "./WizardEnvironment.vue?vue&type=template&id=1f4bade5"
import script from "./WizardEnvironment.vue?vue&type=script&lang=js"
export * from "./WizardEnvironment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports